module.exports = __webpack_public_path__ + "img/1920x793px.2a20a0d4.png";